import { sendAction } from '@/core/action';
import { isRecord, isString } from '@/utils/validator';

export enum PROJECTS {
  guides = 'guidesInGame',
  inGameNews = 'newsInGame',
  playTogether = 'playTogetherInGame',
  profile = 'playerStats',
  clans = 'clansInGame',
  clanInvites = 'clanInvites',
  clanWars = 'clanWarsInGame',
  warehouse = 'warehouseInGame',
  shop = 'shopInGame',
  metaShop = 'metaShop',
  shipyard = 'shipyardInGame',
  catalogue = 'catalogueInGame',
}

export interface ActionGoToWebProjects {
  actionId: 'goToWebProject',
  projectId: PROJECTS,
  path: string,
}

export function isProjectId(value: unknown): value is PROJECTS {
  return (
    isString(value) &&
    Object.values(PROJECTS).includes(value as PROJECTS)
  );
}

export function isGoToWebProjectAction(a: unknown): a is ActionGoToWebProjects {
  if (!isRecord(a)) {
    return false;
  }

  if (a.actionId !== 'goToWebProject') {
    return false;
  }

  return (
    isString(a.path) &&
    isString(a.projectId) &&
    isProjectId(a.projectId)
  );
}

export function goToWebProject(projectId: PROJECTS, path = '') {
  return sendAction({
    actionId: 'goToWebProject',
    projectId,
    path,
  });
}